import { STATUS } from "#candidate/constants"
import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputFilePDF from "#core/components/input/file/InputFilePDF"
import { useApiSend } from "#hooks/useApiSend"
import { Box, Button } from "@mui/material"
import { Fragment, useCallback, useState } from "react"

export default function CandidateStatusFinal() {
	const { candidateId } = useCandidateRedux()
	const [open, setOpen] = useState(false)
	const [offer, setOffer] = useState(null)
	const [disabled, setDisabled] = useState(false)

	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })

	const handleFetch = useCallback(() => {
		let formData = new FormData()
		formData.append("status", STATUS.OFFER)
		formData.append("offer", offer)
		setDisabled(true)
		fetch(candidateId, formData)
	}, [candidateId, offer, fetch])

	return (
		<Fragment>
			<Button onClick={() => setOpen(!open)}>Subir Propuesta</Button>
			<DialogMaster
				open={open}
				setOpen={setOpen}
				maxWidth="sm"
				title="propuesta"
				handleSubmit={handleFetch}
				disabled={disabled}
			>
				<Box display="flex" flexDirection="column" gap={2} alignItems={"center"}>
					<InputFilePDF label="Subir Propuesta" value={offer} setValue={setOffer} />
				</Box>
			</DialogMaster>
		</Fragment>
	)
}
